(function(){
  if(window.__xtxCompareResetBound)return;
  window.__xtxCompareResetBound=true;

  function injectMobileSnapFix(){
    if(document.getElementById('xtx-compare-mobile-snap-fix'))return;
    var style=document.createElement('style');
    style.id='xtx-compare-mobile-snap-fix';
    style.textContent='@media(max-width:749px){html body .xtx-compare .xtx-compare__scroll[data-xtx-carousel]{scroll-snap-type:none!important;scroll-padding-left:0!important;scroll-behavior:auto!important;overscroll-behavior-x:contain!important;}html body .xtx-compare .xtx-compare-table .xtx-compare-product{scroll-snap-align:none!important;}html body .xtx-compare .xtx-compare-table{transform:translateZ(0)!important;}}';
    document.head.appendChild(style);
  }

  function resetCompare(root){
    injectMobileSnapFix();
    (root||document).querySelectorAll('.xtx-compare__scroll[data-xtx-carousel]').forEach(function(track){
      track.dataset.xtxResetting='1';
      track.style.scrollSnapType='none';
      track.scrollLeft=0;
      if(track.scrollTo)track.scrollTo({left:0,behavior:'auto'});
      window.requestAnimationFrame(function(){track.scrollLeft=0;if(track.scrollTo)track.scrollTo({left:0,behavior:'auto'});});
      [60,160,360,800,1400].forEach(function(delay){
        window.setTimeout(function(){
          track.style.scrollSnapType='none';
          track.scrollLeft=0;
          if(track.scrollTo)track.scrollTo({left:0,behavior:'auto'});
          if(delay===1400)delete track.dataset.xtxResetting;
        },delay);
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){resetCompare(document);});
  document.addEventListener('shopify:section:load',function(event){resetCompare(event.target);});
  document.addEventListener('shopify:section:select',function(event){resetCompare(event.target);});
  document.addEventListener('shopify:block:select',function(event){resetCompare(event.target);});
  window.addEventListener('pageshow',function(){resetCompare(document);});
  window.addEventListener('resize',function(){resetCompare(document);});
  window.setTimeout(function(){resetCompare(document);},500);
})();
